// PRO Portfolio Diversification & Optimization — protected dashboard page.
//
// Mounted at /dashboard/portfolio-diversification-optimizer-pro behind
// <ProtectedRoute>. Reuses the shared Layout + Sidebar shell so it feels like
// the rest of the internal product, mirroring the Drift Auditor PRO page.

import { Sparkles } from "lucide-react";

import { GlobalSearchBar } from "../global-search";
import { Layout, Sidebar } from "../../shared/ui";
import { DiversificationOptimizerProDashboard } from "./DiversificationOptimizerProDashboard";

export const DiversificationOptimizerProPage = () => (
  <Layout
    sidebar={<Sidebar />}
    title="My Portfolio Optimizer PRO"
    subtitle="Institutional 5-pillar diversification, risk attribution and HRP / ERC / Max-Diversification optimization."
  >
    {/* Platform-wide asset search — sits directly below the page title /
        subtitle so the user can jump to any deep-dive from here. */}
    <div className="mb-6">
      <GlobalSearchBar />
    </div>

    <div className="mb-5 flex flex-wrap items-center gap-2">
      <span className="inline-flex items-center gap-1.5 rounded-full bg-gradient-to-r from-indigo-600 to-violet-600 px-3 py-1 text-[11px] font-black uppercase tracking-wider text-white shadow-lg shadow-indigo-500/30">
        <Sparkles className="h-3.5 w-3.5" /> PRO · Unlocked
      </span>
      <span className="text-sm text-slate-500 dark:text-slate-400">
        Correlation contagion, Euler risk attribution, factor OLS, tail stress and six rebalancing
        simulations in one cockpit.
      </span>
    </div>

    <DiversificationOptimizerProDashboard />
  </Layout>
);
